export default {
    entityKey: 'steps',
    titles: {
        singular: 'Step',
        plural: 'Steps'
    }
}
